<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="600">
        <v-card>
            <v-card-title id="heading" class="d-flex justify-space-between">
                <h4>Invite User to a "{{ company.company_name }}" Company</h4>
                <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
            </v-card-title>

            <v-container>
                <v-form v-model="formData.valid" class="mb-3" validate-on="input lazy" @submit.prevent="inviteUser">
                    <v-alert v-if="errors.length"
                             class="mb-3 bg-error"
                             closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-select v-model="formData['role_id']" :items="filteredRoles" :rules="[vRules.required]"
                                      density="compact" item-value="id" label="Role"/>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="formData['first_name']"
                                          :rules="[vRules.required]" autofocus density="compact" label="First Name"/>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="formData['last_name']"
                                          :rules="[vRules.required]" density="compact" label="Last Name"/>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="formData['email']" :rules="[vRules.required, vRules.email]"
                                          density="compact" label="Email"/>
                        </v-col>

                        <v-col class="py-0 text-right" cols="12">
                            <v-btn :disabled="!formData.valid || processing" :loading="processing" color="primary"
                                   size="small" type="submit">Save
                            </v-btn>
                        </v-col>
                    </v-row>

                </v-form>
            </v-container>
        </v-card>
    </v-dialog>
</template>


<script setup>
import {computed, reactive, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const emits = defineEmits(['update:modelValue', 'updateInvitedUser', 'refreshInvites']);
const snackbar = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    company: Object,
    roles: Array
});
const errors = ref([]);
const processing = ref(false);
const dialogSwitch = ref(props.modelValue);
const formData = reactive({
    valid: false,
    company_id: props.company.id,
    role_id: null,
    first_name: null,
    last_name: null,
    email: null,
});

const filteredRoles = computed(() => {
    return props.roles.filter((role) => role.role_type === 'api' || parseInt(role.portal_id) === parseInt(props.company.portal_id));
})
const inviteUser = () => {
    errors.value = [];
    processing.value = true;
    send('post', `users/invite`, formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                processing.value = false;
                emits('updateInvitedUser', response.data.data.invite);
                emits('update:modelValue', false);
                snackbar.showSnackbar(response.data.message);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response?.data?.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response?.data?.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            processing.value = false;
            if (!errors.value.length) snackbar.showSnackbar('Something went wrong', 'error');
            // Saved even though its email failed, so it belongs in the pending list now.
            if (errorResponse.response?.status === 503) emits('refreshInvites');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}
</script>
